module.exports = __webpack_public_path__ + "img/project5.445f08fc.png";